// extracted by mini-css-extract-plugin
export default {"externalLink":"ExternalLink_externalLink__JegFC"};